import axios from "axios";
import * as Config from "./Config";

type Intent = {
   resourceName: string;
   serviceName: string;
   appstackName: string;
   operationNameSet: string[] | null;
};

export type T = Intent;

type GetIntentResponse = {
   response: {
      permissions: Intent[];
   };
};

export const fetchForCurrentUser = async (): Promise<Intent[]> => {
   try {
      const res = await axios.get<GetIntentResponse>(
         `${Config.get().base_path}auth/intents`
      );
      return res.data.response.permissions;
   } catch (exn) {
      console.error("Failed to fetch Intents", exn);
      return [];
   }
};
